import DataGrid, { Column, ColumnChooser, Grouping, GroupPanel, Pager, Paging, SearchPanel } from "devextreme-react/data-grid";
import { MovementTypeColumn } from "./MovementTypeColumn";
import { ISettlementAdvanceHolderTransactionRecordDto } from "../../../dtos/transactions/ISettlementAdvanceHolderTransactionRecordDto";

interface IProps {
  items: ISettlementAdvanceHolderTransactionRecordDto[];
}

export const SettlementAdvanceHolderTransactionRecordTable = ({ items }: IProps) => {
  const pageSizes = [10, 25, 50, 100];

  return (
    <>
      <DataGrid
        dataSource={items}
        sorting={{ mode: "multiple" }}
        allowColumnReordering={true}
        rowAlternationEnabled={false}
        showBorders={false}
        showRowLines={true}
        allowColumnResizing={true}
        selection={{ mode: "single" }}
        loadPanel={{ enabled: true, showIndicator: true, showPane: false }}
        onSelectionChanged={async (e) => {}}
      >
        <ColumnChooser enabled={true} />
        <GroupPanel visible={true} />
        <SearchPanel visible={true} highlightCaseSensitive={true} />
        <Grouping autoExpandAll={false} />

        <Column
          dataField="tableMovementType"
          dataType="string"
          caption={"Movement Type"}
          width={100}
          cellRender={(column: any) => {
            return <MovementTypeColumn column={column} />;
          }}
        />

        <Column dataField={"period"} dataType={"datetime"} caption={"Period"} sortOrder={"asc"} sortIndex={1} />
        <Column dataField={"companyName"} dataType="string" />
        <Column dataField={"expenseItemName"} dataType="string" />
        <Column dataField={"companyId"} dataType="string" />
        <Column dataField={"employeeId"} dataType="string" />
        <Column dataField={"currencyName"} dataType="string" />
        <Column dataField={"cashRegisterId"} dataType="string" />
        <Column dataField={"cashRegisterName"} dataType="string" />
        <Column dataField={"amount"} dataType="number" format={"fixedPoint"} />

        <Pager allowedPageSizes={pageSizes} showPageSizeSelector={true} />
        <Paging defaultPageSize={10} />
      </DataGrid>
    </>
  );
};
